import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BaseDialogOptions } from '../dialogoptions';
var SelectBoxDialogComponent = /** @class */ (function () {
    function SelectBoxDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.title = data.TitleText || 'Information';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.options = data.Options || [];
        this.placeholder = data.Placeholder || 'Select choice...';
        this.current = data.Current;
        this.selection = data.Current;
        this.showIcon = data.ShowIcon;
    }
    SelectBoxDialogComponent.prototype.ngOnInit = function () { };
    SelectBoxDialogComponent.prototype.CancelHandler = function () {
        this.dialogRef.close(null);
    };
    SelectBoxDialogComponent.prototype.OKHandler = function () {
        this.dialogRef.close(this.selection);
    };
    return SelectBoxDialogComponent;
}());
export { SelectBoxDialogComponent };
var BaseSelectBoxDialogOptions = /** @class */ (function (_super) {
    tslib_1.__extends(BaseSelectBoxDialogOptions, _super);
    function BaseSelectBoxDialogOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseSelectBoxDialogOptions;
}(BaseDialogOptions));
export { BaseSelectBoxDialogOptions };
var BaseSelectBoxSelectionOption = /** @class */ (function () {
    function BaseSelectBoxSelectionOption() {
    }
    return BaseSelectBoxSelectionOption;
}());
export { BaseSelectBoxSelectionOption };
